import '@mrhenry/wp--bugsnag-config';
import '@mrhenry/wp--autoplay-in-view';

import { PrivacyControls, MrDisplayValue } from '@mrhenry/wp--mr-interactive';

/* Modules */
import './modules/input-sink';
import './modules/mr-accordion';
import './modules/mr-carousel';
import './modules/mr-hotspot';
import './modules/mr-video';
import './modules/mr-video-overlay';
import './modules/navigation-overlay';
import './modules/play-pause-toggle';
import './modules/track-link-clicks';

customElements.define( 'mr-display-value', MrDisplayValue );

PrivacyControls.setupPrivacyAwareEmbedders();
